// extracted by mini-css-extract-plugin
export default {"header":"Work_header__c5df2","container":"Work_container__992xG"};